import styled, { css } from 'styled-components';
import variables from '@styles/variables';
import { rem } from 'polished';

export const StyledSlotDate = styled.button<{ selected: boolean }>`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  background-color: ${variables.colors.white};
  cursor: pointer;
  height: ${rem(65)};
  margin: 0;
  padding: 0;
  border: ${rem(1)} solid ${variables.colors.mediumGray};
  border-radius: ${rem(4)};
  overflow: hidden;

  ${(props) =>
    props.selected &&
    css`
      border: ${rem(2)} solid ${variables.colors.highlight};
      margin: 0 ${rem(-1)};
    `}
`;

export const StyledSlotDateName = styled.div<{ selected: boolean }>`
  line-height: ${rem(24)};
  font-family: ${variables.fonts.fontGothamMedium};
  font-size: ${rem(13)};
  text-transform: uppercase;
  background: ${variables.colors.lightGray};
  width: 100%;
  height: ${rem(25)};
  display: flex;
  justify-content: center;
  align-items: center;

  ${(props) =>
    props.selected &&
    css`
      background: ${variables.colors.highlight};
      color: ${variables.colors.white};
    `}
`;

export const StyledSlotDateText = styled.div<{ selected: boolean }>`
  line-height: ${rem(24)};
  font-family: ${variables.fonts.fontGothamMedium};
  font-size: ${rem(15)};
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${rem(40)};
  width: 100%;
`;
